import { render, staticRenderFns } from "./UpdateBanner.vue?vue&type=template&id=b24f4c1e&scoped=true&"
import script from "./UpdateBanner.vue?vue&type=script&lang=js&"
export * from "./UpdateBanner.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBanner.vue?vue&type=style&index=0&id=b24f4c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24f4c1e",
  null
  
)

export default component.exports